module.exports = __webpack_public_path__ + "static/img/img_yewu3.d8868b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_yewu3.png
// module id = pyKB
// module chunks = 1